<template>
    <tr class="search-result">
        <td>
            <picture>
                <source type="image/webp" :srcset="vehicle.first_image[1]">
                <img :src="vehicle.first_image[0]" class="img-responsive saved-vehicle-new__img">
            </picture>
        </td>
        <td class="saved-vehicle-new__version">
            <span class="saved-vehicle-new__name">{{ vehicle.display_name }}</span>
            {{ vehicle.version }}
        </td>
        <td>{{ vehicle.transmission }}</td>
        <td>{{ vehicle.fuel_type }}</td>
        <td>{{ mpgOrRange }}</td>
        <td>{{ numberFormat(vehicle.co2, 0) }} g/km</td>
        <td>{{ numberFormat(vehicle.engine_bhp, 0) }} bhp</td>
        <td>
            <span v-if="!isMotab" class="price">
                &pound;{{ numberFormat(vehicle.pricing_display_price, 0) }}
                <span v-if="vehicle.type == 'van'" class="vat-message">(excluding VAT)</span>
            </span>
            <template v-else>
                Civilian Advance Payment: &pound;{{ civAllowance }}<br />
                Civilian Monthly Allowance: &pound;{{ civAdvancePayment }}<br />
                War Pensioner Advance Payment: &pound;{{ warAllowance }}<br />
                War Pensioner Monthly Allowance: &pound;{{ warAdvancePayment }}
            </template>
        </td>
        <td class="actions">
            <button class="btn btn--fake-link" @click="remove">Remove from saved vehicles</button><br>
            <a v-if="!isMotab" :href="vehicle.vehicle_link" class='link'>View details</a>
            <a v-else :href="vehicle.motability_link" class='link'>View details</a>
        </td>
    </tr>
</template>

<script>
import numberFormat from '../api/NumberFormat';

export default {
    props: {
        isMotab: {
            type: Boolean,
            required: false,
            default: false,
        },
        vehicle: {
            type: Object,
            required: true,
            default: {},
        }
    },
    computed: {
        civAllowance() {
            return numberFormat(this.vehicle.motab_civ_allowance, 0);
        },
        civAdvancePayment() {
            return numberFormat(this.vehicle.motab_civ_advance_payment, 0);
        },
        warAllowance() {
            return numberFormat(this.vehicle.motab_war_allowance, 0);
        },
        warAdvancePayment() {
            return numberFormat(this.vehicle.motab_war_advance_payment, 0);
        },
        mpgOrRange() {
            if (this.vehicle.hybrid_mpg_min !== null && this.vehicle.hybrid_mpg_min > 0) {
                if (this.vehicle.hybrid_mpg_max !== null && this.vehicle.hybrid_mpg_max > 0) {
                    return numberFormat(this.vehicle.hybrid_mpg_min, 0) + ' to ' + numberFormat(this.vehicle.hybrid_mpg_max, 0) + ' mpg';
                }
                return numberFormat(this.vehicle.hybrid_mpg_min, 0) + ' mpg';
            } else if (this.vehicle.hybrid_mpg_max !== null && this.vehicle.hybrid_mpg_max > 0) {
                return 'Up to ' + numberFormat(this.vehicle.hybrid_mpg_max, 0) + ' mpg';
            } else if (this.vehicle.mpg_combined !== null && this.vehicle.mpg_combined > 0) {
                return numberFormat(this.vehicle.mpg_combined, 0) + ' mpg';
            } else if (this.vehicle.max_ev_range > 0) {
                if (this.vehicle.min_ev_range > 0) {
                    return numberFormat(this.vehicle.min_ev_range, 0) + ' to ' + numberFormat(this.vehicle.max_ev_range, 0) + ' miles';
                }
                return 'Up to ' + numberFormat(this.vehicle.max_ev_range, 0) + ' miles';
            } else if (this.vehicle.min_ev_range > 0) {
                return numberFormat(this.vehicle.min_ev_range, 0) + ' miles';
            }

            return '-';
        }
    },
    methods: {
        numberFormat,
        remove() {
            if (!this.isMotab) {
                this.$store.dispatch('Layout/saveVehicle', {
                    type: 'new',
                    id: this.vehicle.cap_id,
                    add: false,
                }).then(() => {
                    this.$emit('removed-item');
                });
                return;
            }
            this.$store.dispatch('Layout/saveVehicle', {
                type: 'motability',
                id: this.vehicle.cap_id,
                add: false,
            }).then(() => {
                this.$emit('removed-item');
            });
        }
    },
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/NewVehicleResult.vue